import { App } from 'vue';
import { reportVideoPlayEvent } from '@/composables/user-activity-monitor';
import { onVideoPlaySymbol, mediaLoggerSymbol } from '@tmi/media';
import { createDefaultLogger } from '@/types/console-logger';

const logger = createDefaultLogger();

const MediaPlugin = {
    install( app: App< Element > ) {
        app.provide( onVideoPlaySymbol, reportVideoPlayEvent );
        app.provide( mediaLoggerSymbol, logger );
    }
};

export default MediaPlugin;
